import { SnackbarManager } from '@cmg/design-system';
import { useCallback } from 'react';

import type { RelationshipType, RolodexRecordStatus } from '../../../../../../graphql';
import {
  useAdminUpdateRelationshipMutation,
  useUpdateRelationshipMutation,
} from '../graphql/__generated__';

type UpdateRelationshipParams = {
  firmId: string;
  employeeId: string;
  status: RolodexRecordStatus;
  relationshipType: RelationshipType;
};

export type UseUpdateRelationshipParams = {
  tenantId?: string;
  onComplete: () => void;
};

export function useUpdateRelationship({ tenantId, onComplete }: UseUpdateRelationshipParams) {
  const [updateRelationshipAsCustomer] = useUpdateRelationshipMutation();
  const [updateRelationshipAsAdmin] = useAdminUpdateRelationshipMutation();

  return useCallback(
    async ({ firmId, employeeId, status, relationshipType }: UpdateRelationshipParams) => {
      try {
        if (tenantId) {
          await updateRelationshipAsAdmin({
            variables: {
              input: {
                tenantId,
                firmId,
                underwriterEmployeeId: employeeId,
                input: {
                  status,
                  relationshipType,
                },
              },
            },
          });
        } else {
          await updateRelationshipAsCustomer({
            variables: {
              firmId,
              underwriterEmployeeId: employeeId,
              input: {
                status,
                relationshipType,
              },
            },
          });
        }
        onComplete?.();
      } catch {
        SnackbarManager.error('Failed to update relationship');
      }
    },
    [tenantId, updateRelationshipAsAdmin, updateRelationshipAsCustomer, onComplete]
  );
}
